import { List, type ListProps } from "@refinedev/mui";

type Props = {
    title?: React.ReactNode;
} & ListProps;

export const RefineListView = ({ children, title, ...props }: Props) => {
    return (
        <List
            {...props}
            title={title}
            headerProps={{
                sx: {
                    display: "flex",
                    flexWrap: "wrap",
                    ".MuiCardHeader-action": {
                        margin: 0,
                        alignSelf: "center",
                    },
                    height: "72px",
                },
            }}
            headerButtonProps={{
                alignItems: "center",
                ...props.headerButtonProps,
            }}
            wrapperProps={{
                sx: {
                    backgroundColor: "transparent",
                    backgroundImage: "none",
                    boxShadow: "none",
                    ...props.wrapperProps?.sx,
                },
            }}
        >
            {children}
        </List>
    );
};